import { NotFoundPage } from "@/modules/error/ErrorFallback.tsx";
import { Outlet, createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
    component: RootComponent,
    notFoundComponent: NotFoundPage,
});

function RootComponent() {
    return <Outlet />;
}
